import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { Grid } from "@material-ui/core";
import { togglenAdminUser } from "Constants/Constants";
import { FACTOR_RESULT } from "Stores/actionTypes";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from 'react-i18next';
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";

export default function SettingsPriceType({ArchiveFactor}) {
  const { t } = useTranslation();
  const { factorResult, selectedProject } = useSelector((state) => ({
    factorResult: state.factor.factorResult,
    selectedProject: state.project.selectedProject,
  }));
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    TypePriceProfile: {
      type: "toggle",
      arrayItems: togglenAdminUser,
      value: togglenAdminUser[0],
      label: 'priceProfile',
      validation: {
        required: true,
      },
    },
    TypePriceFitting: {
      type: "toggle",
      arrayItems: togglenAdminUser,
      value: togglenAdminUser[0],
      label: 'priceFitting',
      validation: {
        required: true,
      },
    },
    TypePriceGlass: {
      type: "toggle",
      arrayItems: togglenAdminUser,
      value: togglenAdminUser[0],
      label: 'priceGlass',
      validation: {
        required: true,
      },
    },
    TypePriceNet: {
      type: "toggle",
      arrayItems: togglenAdminUser,
      value: togglenAdminUser[0],
      label: 'priceNet',
      validation: {
        required: true,
      },
    },
    TypePriceOther: {
      type: "toggle",
      arrayItems: togglenAdminUser,
      value: togglenAdminUser[0],
      label: 'priceOther',
      validation: {
        required: true,
      },
    },
    IdFactorArchive: {
      type: "select",
      selectItems: [],
      value: 0,
      validation: null,
    },
  });

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
    const result = {
      ...factorResult,
      [name]: value.value,
    };
    dispatch({ type: FACTOR_RESULT, factorResult: result });
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    const result = {
      ...factorResult,
      [controlName]: value.Id ? value.Id : 0,
    };
    dispatch({ type: FACTOR_RESULT, factorResult: result });
  };

  useEffect(() => {
    setControls({ IdFactorArchive: { selectItems: ArchiveFactor } });
    if(factorResult.TypePriceProfile) setControls({TypePriceProfile: {value: analyseValue(factorResult.TypePriceProfile)}})
    if(factorResult.TypePriceFitting) setControls({TypePriceFitting: {value: analyseValue(factorResult.TypePriceFitting)}})
    if(factorResult.TypePriceGlass) setControls({TypePriceGlass: {value: analyseValue(factorResult.TypePriceGlass)}})
    if(factorResult.TypePriceNet) setControls({TypePriceNet: {value: analyseValue(factorResult.TypePriceNet)}})
    if(factorResult.TypePriceOther) setControls({TypePriceOther: {value: analyseValue(factorResult.TypePriceOther)}})

    if(factorResult.IdFactorArchive && factorResult.IdFactorArchive !== 0) {
      const selected = ArchiveFactor.filter((item) => item.value === factorResult.IdFactorArchive);
      setControls({ IdFactorArchive: { value: selected[0] } });
    }
  }, []);

  const analyseValue = (value) => {
    return togglenAdminUser.find(i => i.value === value)
  }

  return (
    <Grid container spacing={2} className="px-3 pb-3 mt-4">
      <Grid container spacing={2}>
        <Grid item lg={3} md={4} sm={6} xs={12}>
          <MuiAutoComplete
            options={controls.IdFactorArchive.selectItems}
            label={<Translator id='Select_price_from_archived_invoice'/>}
            value={controls.IdFactorArchive.value}
            id="IdFactorArchive"
            onChange={autoCompleteHandler}
          />
        </Grid>
      </Grid>
      {
        Object.keys(controls).filter(key => controls[key].type === "toggle").map((key, index) => {
          return (
            <Grid item md={4} sm={6} xs={12}>
              <MuiRadioGroup
                name={key}
                label={<Translator id={controls[key].label}/>}
                value={controls[key].value}
                items={controls[key].arrayItems}
                onChange={onChangeToggle}
                translate={true}
                className="horizontalRadio"
              />
            </Grid>
          )
        })
      }
    </Grid>
  );
}